import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { fontExtraBold } from 'style/styled-components/cssGlobalVariables';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';
import { buttonReset } from 'style/styled-components/cssButtonReset';

export const OptionsContent = styled.div`
    width: 100%;
    position: relative;
    padding: 20px;
    overflow-x: hidden;

    ${MQ(Breakpoints.s)} {
        position: relative;
        top: auto;
        left: auto;
        transform: none;
        padding: 16px;
    }

    ${MQ(Breakpoints.m)} {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const OptionTitle = styled.h2`
    width: 100%;
    font-size: 32px;
    padding-bottom: 8px;
    line-height: 32px;
    white-space: normal;
    font-family: ${fontExtraBold};
    font-weight: 800;
    position: relative;
    text-align: center;
    margin: 48px 0 0;

    ${MQ(Breakpoints.m)} {
        margin-top: 0;
    }
`;

export const OptionSubtext = styled.div`
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: var(--color-dark-body-70);
    padding-bottom: 32px;
    position: relative;
    line-height: 24px;
    padding-right: 24px;
    padding-left: 24px;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;

    @media screen and (min-width: 640px) {
        padding-bottom: 40px;
    }
`;

export const CardWrapper = styled.div<{ $isScrollable?: boolean }>`
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    ${(props) =>
        props.$isScrollable
            ? `
        flex-wrap: nowrap;
        justify-content: flex-start;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-behavior: smooth;
        padding: 8px 0;
        
        scrollbar-width: none;
        -ms-overflow-style: none;
        
        &::-webkit-scrollbar {
            display: none;
        }
    `
            : `
        flex-wrap: wrap;
    `}
`;

export const SubscriptionCardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    max-height: 60vh
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 16px 16px 16px;


    ${MQ(Breakpoints.s)} {
        max-height: 70vh;
        padding: 0 8px 16px 8px;
        gap: 12px;
    }
`;

export const CardLandscapeWrapper = styled.div`
    border-radius: 8px;
`;

const NavigationIcon = styled.button`
    ${buttonReset}
    cursor: pointer;

    &:hover {
        background: var(--color-dark-foreground-15);

        svg {
            color: var(--color-main-white);
        }
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }
`;

export const BackButton = styled(NavigationIcon)`
    position: absolute;
    left: 16px;
    top: 6px;
    background: var(--color-dark-foreground-5);
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${MQ(Breakpoints.s)} {
        top: 16px;
        left: 26px;
    }

    ${MQ(Breakpoints.m)} {
        left: 46px;
    }

    svg {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-left: -2px;
    }
`;

export const CardWrapperScrollable = styled.div<{ $isScrollable?: boolean }>`
    width: 100%;
    position: relative;
    display: flex;
    align-items: stretch;

    ${(props) =>
        props.$isScrollable
            ? `
        flex-wrap: nowrap;
        justify-content: flex-start;
        overflow-x: auto;
        overflow-y: hidden;
        scroll-behavior: smooth;
        padding: 8px 0;
        gap: 0;

        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            display: none;
        }
    `
            : `
        flex-wrap: wrap;
        justify-content: center;
        gap: 16px;
        padding: 8px 0;
    `}
`;

export const CardServiceWrapper = styled.div<{ $isScrollable?: boolean }>`
    display: flex;
    align-items: stretch;
    flex-shrink: 0;

    ${(props) =>
        props.$isScrollable
            ? `
        flex: 0 0 auto;
    `
            : `
        flex: 0 0 auto;
    `}
`;

export const ScrollWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const ScrollButton = styled.button<{ position: 'left' | 'right' }>`
    position: absolute;
    top: 50%;
    ${(props) => props.position}: 5px;
    transform: translateY(-50%);
    background: var(--color-dark-foreground-5);
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: background 150ms ease-in-out;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5);

    &:hover {
        background: var(--color-dark-foreground-15);

        svg {
            color: var(--color-main-white);
        }
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }

    svg {
        width: 18px;
        height: 18px;
    }

    ${MQ(Breakpoints.m)} {
        ${(props) => props.position}: 10px;
    }
`;
